import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { textInCapitalCase } from '../../../../../../helpers/TextHelper';
import { formatDateForGiftCards } from '../../../../../../helpers/DateFormatter';

const InfoText = ({ ...props }) => {
  const { title, description, date, type } = props;
  return (
    <Box display="flex">
      <Typography
        variant="h4"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        data-cy={`infoText${type}`}
      >
        <strong> {title} </strong>
        &nbsp;
        {date
          ? formatDateForGiftCards(description)
          : textInCapitalCase(description)}
      </Typography>
    </Box>
  );
};

InfoText.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  date: PropTypes.bool,
  type: PropTypes.string,
};

export default InfoText;
